import React from 'react';

function Footer() {
    return(
        <footer>
		    <p className="copyright">	
            Copyright &copy;All rights reserved | This template is made with <i class="ion-heart" aria-hidden="true"></i> by Klaus H. Hutasuhut
		    </p>
	    </footer>
    );
}

export default Footer;